import { Text, View } from "@react-pdf/renderer";
import styles from '../styles/styles';
import Element from "./element";

interface ScreeningDateProps {
  labels: {
    header: string;
    subHeader: string;
  };
  data: {
    date: string | null | undefined;
  };
}

const ScreeningDate = ({ labels, data }: ScreeningDateProps) => (
  <>
    <View style={styles.row}>
      <Text style={styles.subHeader}>{labels.header}</Text>
    </View>

    {data.date !== undefined && <>
      <View style={styles.miniSpacer} />

      <View style={styles.row}>
        <Element label={labels.subHeader} data={data.date} />
      </View>
    </>}
  </>
);

export default ScreeningDate;